import { Button, Dialog, DialogActions, DialogContent, Grid, List, ListItem, Paper, styled, SvgIcon, Typography } from "@mui/material";
import { Form } from "formik";
import FormikAutocomplete from "../commons/formik/FormikAutocomplete";
import FormikCheckbox from "../commons/formik/FormikCheckbox";
import FormikDateTimePicker from "../commons/formik/FormikDateTimePicker";
import HeaderForm from "../commons/labels/HeaderForm";

export const StyledNuevaDenuncia = {
    Button: styled(Button)(({ theme }) => ({
        margin: "10px",
        width: "80px",
    })),
    SearchContainer: styled("div")(({ theme }) => ({
        padding: "35px",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        padding: "20px",
    })),
    Mensaje: styled("div")(({ theme }) => ({
        display: "flex",
        height: "300px",
        justifyContent: "center",
        alignItems: "center",
    })),
    GridContainer: styled(Grid)(({ theme }) => ({
        paddingRight: "35px",
        paddingLeft: "35px",
        paddingTop: "15px",
    })),
    ButtonContainerForm: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        padding: "25px",
    })),
    FormContainer: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        marginTop: "50px",
    })),
    LoadingContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
    })),
    TableIcon: styled(SvgIcon)(({ theme }) => ({
        marginLeft: "10px",
    })),
    TableFooter: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    })),
    TableButtonContainer: styled("div")(({ theme }) => ({
        margin: "0px 25px 0px 0px",
        "& button": {
            marginLeft: "10px",
        },
    })),
    RowContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        alignItems: 'center',
        width: "100%",
    })),
    InputContainer: styled("div")(({ theme }) => ({
        width: "100%",
        marginBottom: "20px",
    })),
    Input: styled(FormikAutocomplete)(({ theme }) => ({
        minWidth: 0,
        width: '100%',
        '& .MuiAutocomplete-root': {
            width: '100% !important',
        },
        '& .MuiFormControl-root': {
            width: '100% !important',
        },
        '& .MuiInputBase-root': {
            width: '100% !important',
        }
    })),
    DialogLoading: styled(DialogContent)(({ theme }) => ({
        marginTop: "40px",
        marginBottom: "80px",
    })),
    Checkbox: styled(FormikCheckbox)(({ theme }) => ({
        marginLeft: "20px",
    })),
    RightInput: styled(FormikDateTimePicker)(({ theme }) => ({
        marginLeft: "20px",
    })),
    // NroDenunciaDialog
    DialogTitle: styled(HeaderForm)(({ theme }) => ({
        textAlign: "center",
    })),
    NroDenunciaSuccess: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        padding: "30px",
        justifyContent: "space-evenly",
    })),
    Icon: styled(SvgIcon)(({ theme }) => ({
        cursor: "pointer",
        marginLeft: "10px",
    })),
    ErrorText: styled(Typography)(({ theme }) => ({
        padding: "30px",
    })),
};

export const StyledSiniestralidad = {
    FormContainer: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0%",
    })),
    RowContainer: styled("div")(({ theme }) => ({
        display: "flex",
    })),
    FilterItem: styled("div")(({ theme }) => ({
        margin: "10px",
        width: "200px",
    })),
    EstablecimientoCombo: styled("div")(({ theme }) => ({
        margin: "10px",
        width: "420px",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        margin: "20px 0px 0px 10px",
    })),
    List: styled(List)(({ theme }) => ({
        padding: "0px"
    })),
    ListItem: styled(ListItem)(({ theme }) => ({
        padding: "0.5px",
        display: "block",
        wordWrap: "break-word",
    })),
    TableToolbarContainer: styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    })),
    TableFilterItem: styled("div")(({ theme }) => ({
        margin: "10px 0px 10px 25px",
        "& p": {
            fontSize: 12,
            marginTop: 5,
            color: "red",
        },
    })),
    TableTitleContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
    })),
    TableFilterContainer: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        margin: "0px",
    })),
    TableExportButtonContainer: styled("div")(({ theme }) => ({
        paddingTop: 10,
    })),
    InformesMedicos: styled(Typography)(({ theme }) => ({
        margin: "15px 15px",
    })),
    Card: styled(Paper)(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "10px",
        padding: "5px",
        paddingLeft: "10px",
        paddingRight: "10px",
        borderRadius: "5px",
    })),
    EmptyState: styled(Typography)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "100px 20px 20px 50px",
        color: "grey",
        textAlign: "center",
    })),
    ActionsContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
    })),
    ContentContainer: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
    })),
    IconoStyle: styled(Typography)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 10,
        color: theme.palette.secondary.light,
    })),
    GridItem: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    AdjuntarFormularioDialog: styled(Dialog)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    LoadingContainer: styled("div")(({ theme }) => ({
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    // Form
    FormContent: styled(DialogContent)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "calc(100vh - 250px)",
        rowGap: "3vh",
    })),
    FormLoading: styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 300px)",
    })),
    FormRow: styled("div")(({ theme }) => ({
        display: "flex",
        width: "95%",
        columnGap: "1vw",
    })),
    FormObservaciones: styled("div")(({ theme }) => ({
        width: "90%",
        margin: "auto",
    })),
    FormDropzone: styled("div")(({ theme }) => ({
        display: "flex",
    })),
    FormButtonsContainer: styled(DialogActions)(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-end",
        boxShadow: "0px 0 5px lightGrey",
    })),
};